export default {
  content: {
    id: 'product_jp_product_condition_screen_carousel_premium_content',
    defaultMessage: 'Best quality product available on Back Market.',
  },
  pill1: {
    id: 'product_jp_product_condition_screen_carousel_premium_pill_1',
    defaultMessage: '{brand} verified parts',
  },
  grade: {
    id: 'product_jp_grade_9',
    defaultMessage: 'Premium',
  },
}
